import { render, staticRenderFns } from "./selectLink.vue?vue&type=template&id=03d80ac0&scoped=true"
import script from "./selectLink.vue?vue&type=script&lang=js"
export * from "./selectLink.vue?vue&type=script&lang=js"
import style0 from "./selectLink.vue?vue&type=style&index=0&id=03d80ac0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d80ac0",
  null
  
)

export default component.exports